import { render, staticRenderFns } from "./FpLoader.vue?vue&type=template&id=24237007&lang=pug&"
import script from "./FpLoader.vue?vue&type=script&lang=js&"
export * from "./FpLoader.vue?vue&type=script&lang=js&"
import style0 from "./FpLoader.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports